import {Component} from 'vue-property-decorator';
import {ComponentEventBus} from '@/store';
import DefaultComponentMixin from '@/views/DefaultComponentMixin';

/**
 * 모든 View가 적용해야 할 Mixin
 */
@Component
export default class DefaultViewMixin extends DefaultComponentMixin {
    
    public beforeDestroy() {
        this.$modal.hideSponsorSelectDialog();
        this.$modal.hideReasonDialog();
        this.$modal.hideAuditTrailDialog();
        this.$modal.hideItemAuditTrailDialog();
    }
    
    protected destroyed() {
        ComponentEventBus.$off('refresh');
        ComponentEventBus.$off('languageChanged');
        ComponentEventBus.$off('appendixChanged');
        ComponentEventBus.$off('filterCleared');
    }
    
    
}
